import React, { useState } from 'react';
import { SkillProps } from './types';
import { FieldTextInput } from '../FieldTextInput';
import AddImage from '../AddImage/AddImage';
import { Paper } from '@material-ui/core';
import { storage } from '../../resources/storage';

const Skill: React.FC<SkillProps> = (props) => {
    const [image, setImage] = useState(props.skill.image ?? '');
    return (
        <Paper className="skill" elevation={2}>
            {props.languages.map((lang) => {
                return (
                    <div
                        style={{ display: props.selectedLanguage !== lang.code ? 'none' : 'block' }}
                        key={`${props.skill.id}_${lang.code}`}
                    >
                        <FieldTextInput
                            defaultValue={props.skill.name?.[lang.code]}
                            variant="outlined"
                            required={false}
                            type="text"
                            id={`${props.skill.id}_name_${lang.code}`}
                            label="Skill"
                            name={`${props.skill.id}_name_${lang.code}`}
                        ></FieldTextInput>
                    </div>
                );
            })}
            <FieldTextInput
                value={image}
                hidden={true}
                variant="outlined"
                required={false}
                type="text"
                id={`${props.skill.id}_image_pl`}
                label=""
                name={`${props.skill.id}_image_pl`}
            ></FieldTextInput>
            <AddImage
                path={storage.skills}
                showMessage={false}
                customName={`${props.skill.id}`}
                sendOnDrop={true}
                setGetImgAddress={(url: string) => setImage(url)}
                actualEventFile={image}
            ></AddImage>
        </Paper>
    );
};

export default Skill;
